import { z } from 'zod';

import { isoDatetimeToDate } from './dates';

// Shape returned by `GET /api/v2/promos/active` (already filtered to the
// records this user is eligible to see and has not dismissed). Response
// keys are camelCased by the `Key-Inflection: camel` header on the request.
export const ActivePromo = z.object({
	id: z.string(),
	name: z.string(),
	title: z.string(),
	body: z.string(),
	imageUrl: z.string().nullable().optional(),
	// Set by the backend based on the uploaded file's extension. Drives
	// whether the FE renders an <img> or a <video>.
	mediaType: z.enum(['image', 'video']).nullable().optional(),
	// Optional call-to-action button shown in the modal. When both label
	// and url are present, replaces the default "Got it" dismiss button
	// with a link button. Otherwise the modal falls back to "Got it".
	ctaLabel: z.string().nullable().optional(),
	ctaUrl: z.string().nullable().optional(),
	startsAt: isoDatetimeToDate,
	endsAt: isoDatetimeToDate,
});

export type ActivePromo = z.infer<typeof ActivePromo>;
